import { Media } from 'assets/Mixins.style';
import { css } from 'styled-components';

export const CMS = css`
  display: block;
  max-width: 100%;
  width: 100%;
  color: inherit;
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  cursor: default;
  word-break: break-word;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
  `}

  /* HTML Text */
  p {
    margin-bottom: 25px;
    color: inherit;
  }
  hr{
    margin-bottom:25px;
  }


  .wiersz {
    width: 100%;
    max-width: 100%;
  }

  .wiersz > div {
    float: left;
    padding: 3% 3% 3% 0;
    box-sizing:border-box;
    max-width: 100%;
  }

  .wiersz .jedna_czwarta {
    width: 25%;
  }

  .wiersz .jedna_druga {
    width: 50%;
  }

  .wiersz .trzy_czwarte {
    width: 75%;
  }

  .wiersz .jedna_trzecia {
    width: 33%;
  }

  .wiersz .dwie_trzecie {
    width: 66%;
  }

  .wiersz:after {
    content:"";
    display:table;
    clear:both;
  }

  .wiersz>div:last-of-type:after {
    content:"";
    display:table;
    clear:both;
  }

  @media only screen and (max-width: 590px) {
    .wiersz>div {
      width: 100%!important;
    }
  }
  .menuFooterBox {
    display: flex;
    flex-wrap: wrap;
    font-size: 1.1rem;
    margin-left: -25px;
    ul {
      list-style: none;
      padding: 0 0 0 25px;
    }
    li {
      padding-top: 7px;
      padding-left: 3px;
      ul {
        padding-left: 3px;
      }
    }
    li:first-child {
      padding: 0px;

    }
    a {
      text-decoration: none;
    }
    a:hover {
      color: inherit;
      text-decoration: underline;
    }
  }
  .officeHours {
    font-size: 1.1rem;
    p {
      margin-bottom: 8px;
    }
  }
  .officeHours > b:first-child {
    display: block;
    font-size: 1.2rem;
    padding-bottom: 30px;
    }
  .workHours {
    display: flex;
    width: 100%;
    max-width: 180px;
    justify-content: space-between;
  }
  .workHours:last-of-type {
    padding-bottom: 22px;
  }
  .logoTitle {
    padding-left: 20px;
  }

  h1 {
    margin-bottom: 25px;
    color: inherit;
    font-family: ${props => props.theme.cms.h1.fontFamily};
    font-size: ${props => `${props.theme.cms.h1.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.h1.lineHeight};
    font-weight: ${props => props.theme.cms.h2.fontWeight};


    ${Media.lg`
      font-size: ${props => `${props.theme.cms.h1.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.h1.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.h1.fontSize.sm}rem`};
    `}
  }

  h2 {
    margin-bottom: 25px;
    color: inherit;
    font-size: ${props => `${props.theme.cms.h2.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.h2.lineHeight};
    font-weight: ${props => props.theme.cms.h2.fontWeight};


    ${Media.lg`
      font-size: ${props => `${props.theme.cms.h2.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.h2.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.h2.fontSize.sm}rem`};
    `}
  }

  h3 {
    margin-bottom: 25px;
    color: inherit;
    font-size: ${props => `${props.theme.cms.h2.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.h2.lineHeight};
    font-weight: ${props => props.theme.cms.h2.fontWeight};


    ${Media.lg`
      font-size: ${props => `${props.theme.cms.h2.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.h2.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.h2.fontSize.sm}rem`};
    `}
  }

  h4 {
    margin-bottom: 25px;
    color: inherit;
    font-size: ${props => `${props.theme.cms.h2.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.h2.lineHeight};
    font-weight: ${props => props.theme.cms.h2.fontWeight};


    ${Media.lg`
      font-size: ${props => `${props.theme.cms.h2.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.h2.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.h2.fontSize.sm}rem`};
    `}
  }

  h5 {
    margin-bottom: 25px;
    color: inherit;
    font-size: ${props => `${props.theme.cms.h2.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.h2.lineHeight};
    font-weight: ${props => props.theme.cms.h2.fontWeight};


    ${Media.lg`
      font-size: ${props => `${props.theme.cms.h2.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.h2.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.h2.fontSize.sm}rem`};
    `}
  }

  h6 {
    margin-bottom: 25px;
    color: inherit;
    font-size: ${props => `${props.theme.cms.h2.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.h2.lineHeight};
    font-weight: ${props => props.theme.cms.h2.fontWeight};


    ${Media.lg`
      font-size: ${props => `${props.theme.cms.h2.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.h2.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.h2.fontSize.sm}rem`};
    `}
  }

  /* HTML Text Formatting Elements */
  b {
    font-weight: bold;
  }

  strong {
    font-weight: 900;
  }

  em, i {
    font-style: italic;
  }

  u, ins {
    text-decoration: underline;
  }

  small {
    font-size: smaller;
  }

  mark {
    background-color: ${props => props.theme.cms.mark.background};
    color: inherit;
  }

  del {
    text-decoration: line-through;
  }

  sub {
    font-size: smaller;
    vertical-align: sub;
  }

  sup {
    font-size: smaller;
    vertical-align: super;
  }

  /* HTML Lists */
  ul {
    display: block;
    margin-bottom: 25px;
    padding: ${props => `${props.theme.cms.ul.padding.default}`};
    list-style-type: disc;

    ${Media.md`
      padding: ${props => `${props.theme.cms.ul.padding.md}`};
    `}

    &  ul, &  ol {
      margin-bottom: 0;
    }

    & li::marker {
      color: ${props => props.theme.cms.ul.markerColor};
      font-size: ${props => `${props.theme.cms.ul.markerSize}rem`};
    }
  }

  ol {
    display: block;
    margin-bottom: 25px;
    padding: ${props => `${props.theme.cms.ol.padding.default}`};
    list-style-type: decimal;

    ${Media.md`
      padding: ${props => `${props.theme.cms.ol.padding.md}`};
    `}

    & ul, &  ol {
      margin-bottom: 0;
    }
  }

  li {
    display: list-item;
    text-align: match-parent;
  }

  /* HTML Tables */
  table {
    display: table;
    width: 100%;
    margin-bottom: 25px;
    border-color: ${props => `${props.theme.cms.table.border}`};
    border-collapse: collapse;
    border-spacing: 2px;
  }

  tr {
    display: table-row;
    border-color: inherit;
    background: ${props => `${props.theme.cms.tr.background}`};
    vertical-align: inherit;

    &:nth-child(even) {
      background: ${props => `${props.theme.cms.tr.backgroundAlt}`};
    }
  }

  th {
    padding: 8px;
    border: 1px solid ${props => `${props.theme.cms.th.border}`};
    text-align: left;
  }

  td {
    padding: 8px;
    border: 1px solid ${props => `${props.theme.cms.td.border}`};
    text-align: left;
  }

  /* HTML Image */
  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;

    &.liniowy {
      display: inline-block;
    }
  }

  /* HTML Link */
  a {
    color: ${props => `${props.theme.cms.a.color}`};
    cursor: pointer;
    text-decoration: underline;

  }
  a:hover {
    text-decoration: none;
    color:${props => `${props.theme.cms.a.colorOnHover}`};
  }

  /* HTML Blcokquote */
  blockquote {
    position: relative;
    display: block;
    min-height: 70px;
    margin-bottom: 25px;
    margin-left: ${props => props.theme.cms.blockquote.marginLeft || '20%'};
    padding: ${props => props.theme.cms.blockquote.padding || '25px 20px'};
    color: inherit;
    font-family: ${props => props.theme.cms.blockquote.fontFamily};
    font-size: ${props => `${props.theme.cms.blockquote.fontSize.default}rem`};
    line-height: ${props => props.theme.cms.blockquote.lineHeight};
    font-weight: ${props => props.theme.cms.blockquote.fontWeight};

    ${Media.lg`
      font-size: ${props => `${props.theme.cms.blockquote.fontSize.lg}rem`};
    `}

    ${Media.md`
      font-size: ${props => `${props.theme.cms.blockquote.fontSize.md}rem`};
    `}

    ${Media.sm`
      font-size: ${props => `${props.theme.cms.blockquote.fontSize.sm}rem`};
    `}

    ${props =>
      props.theme.cms.blockquote.quotes &&
      props.theme.cms.blockquote.quotes === 'both' &&
      css`
        margin-right: ${props =>
          props.theme.cms.blockquote.marginRight || '20%'};
      `}

    &:before {
      position: absolute;
      top: 50%;
      right: 100%;
      display: block;
      margin: ${props => props.theme.cms.blockquote.quote.margin.default};
      color: ${props => props.theme.cms.blockquote.quote.color};
      font-family: ${props => props.theme.cms.blockquote.quote.fontFamily};
      font-size: ${props =>
        `${props.theme.cms.blockquote.quote.fontSize.default}rem`};
      line-height: ${props => props.theme.cms.blockquote.quote.lineHeight};
      font-weight: ${props => props.theme.cms.blockquote.quote.fontWeight};
      transform: translateY(-50%);
      content: '„';

      ${Media.lg`
        font-size: ${props =>
          `${props.theme.cms.blockquote.quote.fontSize.lg}rem`};
      `}

      ${Media.md`
        margin: ${props => props.theme.cms.blockquote.quote.margin.md};
        font-size: ${props =>
          `${props.theme.cms.blockquote.quote.fontSize.md}rem`};
      `}

      ${Media.sm`
        margin: ${props => props.theme.cms.blockquote.quote.margin.sm};
        font-size: ${props =>
          `${props.theme.cms.blockquote.quote.fontSize.sm}rem`};
      `}
    }

    ${props =>
      (!props.theme.cms.blockquote.quotes ||
        (props.theme.cms.blockquote.quotes &&
          props.theme.cms.blockquote.quotes !== 'both')) &&
      props.theme.cms.blockquote.quote.background &&
      css`
        &:after {
          position: absolute;
          display: block;
          top: 0;
          bottom: 0;
          left: 0;
          width: 4px;
          background: ${props => props.theme.cms.blockquote.quote.background};
          content: '';
        }
      `}

    ${props =>
      props.theme.cms.blockquote.quotes &&
      props.theme.cms.blockquote.quotes === 'both' &&
      css`
        &:after {
          position: absolute;
          top: 50%;
          left: 100%;
          display: block;
          margin: ${props => props.theme.cms.blockquote.quote.margin.default};
          color: ${props => props.theme.cms.blockquote.quote.color};
          font-family: ${props => props.theme.cms.blockquote.quote.fontFamily};
          font-size: ${props =>
            `${props.theme.cms.blockquote.quote.fontSize.default}rem`};
          line-height: ${props => props.theme.cms.blockquote.quote.lineHeight};
          font-weight: ${props => props.theme.cms.blockquote.quote.fontWeight};
          transform: translateY(-50%);
          content: '„';

          ${Media.lg`
            font-size: ${props =>
              `${props.theme.cms.blockquote.quote.fontSize.lg}rem`};
          `}

          ${Media.md`
            margin: ${props => props.theme.cms.blockquote.quote.margin.md};
            font-size: ${props =>
              `${props.theme.cms.blockquote.quote.fontSize.md}rem`};
          `}

          ${Media.sm`
            margin: ${props => props.theme.cms.blockquote.quote.margin.sm};
            font-size: ${props =>
              `${props.theme.cms.blockquote.quote.fontSize.sm}rem`};
          `}
        }
      `}
  }

  iframe {
    display: inline-block;
    max-width: 100%;
  }
`;
